import { render, staticRenderFns } from "./AdmisionView.vue?vue&type=template&id=0572ded0"
import script from "./AdmisionView.vue?vue&type=script&lang=js"
export * from "./AdmisionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports